// Fechas y nombres que comparten la pantalla de Turnos, el cajón del día y la carga del Excel.
import { DateTime } from "luxon";

export const ZONA = "America/Argentina/Buenos_Aires";

export const MESES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];
export const DIAS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
export const DIAS3 = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
export const DIAS_GRILLA = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

export const capitalizar = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
export const dos = (n: number) => String(n).padStart(2, "0");
export const normalizar = (s: string) =>
  s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

/** En la grilla no entra «Farmacia»: se muestra el nombre propio (maqueta, `short`). */
export const nombreCorto = (nombre: string) =>
  nombre.replace(/^Farmacia (de la |del |de )?/i, "");

/** El turno cambia a las 8:30: antes de esa hora sigue el del día anterior. */
export function turnoActivo(): { fecha: string; terminaHoy: boolean } {
  let ahora = DateTime.now().setZone(ZONA);
  const antesDelCorte = ahora.hour < 8 || (ahora.hour === 8 && ahora.minute < 30);
  if (antesDelCorte) ahora = ahora.minus({ days: 1 });
  return { fecha: ahora.toFormat("yyyy-MM-dd"), terminaHoy: antesDelCorte };
}

/** Fecha de hoy en Tandil, para marcar «Hoy» en la grilla. */
export const hoy = () => DateTime.now().setZone(ZONA).toFormat("yyyy-MM-dd");

/** «el 14», «el 14 y el 22», «el 3, el 14 y el 22». */
export function listarDias(dias: number[]): string {
  const partes = dias.map((d) => `el ${d}`);
  if (partes.length <= 1) return partes.join("");
  return `${partes.slice(0, -1).join(", ")} y ${partes[partes.length - 1]}`;
}
